import { action } from '@ember/object';
import Component from '@glimmer/component';

import { Aggregation } from 'webapp/enums/enums';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';

import type Block from 'webapp/models-custom/block';
import type BlockSetup from 'webapp/models-custom/block-setup';
import type VisualizationGauge from 'webapp/models-custom/visualization/gauge';

interface Args {
	blockM: Block;
}

export default class BlockSettingsShowNumberComponent extends Component<Args> {
	get block(): Block {
		return this.args.blockM;
	}

	get blockSetup(): BlockSetup {
		return this.block.blockSetup;
	}

	get visualization(): VisualizationGauge {
		return this.block.blockSetup.visualization as VisualizationGauge;
	}

	get dataSelect() {
		return this.blockSetup.firstShownDataSelect;
	}

	get selected(): boolean {
		const dataSelect = this.dataSelect;
		return !dataSelect || dataSelect.aggregation === Aggregation.SUM;
	}

	@action
	changeSelected(selected: boolean): void {
		const dataSelect = this.dataSelect;
		if (dataSelect) {
			dataSelect.aggregation = selected ? Aggregation.SUM : null;
			this.blockSetup.saveDataSelect(dataSelect);
		}
	}
	<template>
		<div class="row row--toggle">
			<FormCheckboxSwitchComponent
				@name="showNumber"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>Show current number above</label>
		</div>
	</template>
}
